import { AutogenLayoutSettlement401kTable } from "./autogen/AutogenLayoutSettlement401kTable";
import { OpenType } from "@mcleod/components";

export class Settlement401kTable extends AutogenLayoutSettlement401kTable {
    onLoad(): void | Promise<void> {
        this.table401kDetails.crudManager.defaultOpenType = OpenType.NEW_TAB_WITH_SWITCH;
    }
}
